// @flow

import posthog, { PostHog, Property } from 'posthog-js'

import { logger } from '../../../common'

export const POSTHOG_EVENTS = {
  STARTED: 'Started',
  COMPLETED: 'Completed',
  RECOMMENDED_PRODUCT_CLICKED: 'Recommended product clicked',
  ATC_CLICKED: 'ATC clicked',
  ATC_ROUTINE_BUTTON_CLICKED: 'ATC routine button clicked',
  MATCHING_PANEL_EXPANDED: 'Matching panel expanded',
  PRODUCT_INFO_BUTTON_CLICKED: 'Product info button clicked',
  MORE_PRODUCTS_LOADED: 'More products loaded',
  PRODUCTS_SORTED: 'Products sorted'
}

function posthogApiKey (): ?string {
  return process.env.POSTHOG_API_KEY
}

// only exported for unit test
export function posthogEnabled (): boolean {
  return !!(posthogApiKey())
}

export function initPosthog (subscriberId: string): ?typeof PostHog {
  if (!posthogEnabled()) return

  logger.info(`Initializing Posthog, subscriberId: ${subscriberId} ...`)

  return posthog.init(posthogApiKey(), {
    api_host: 'https://eu.posthog.com',
    autocapture: false,
    capture_pageview: false,
    advanced_disable_decide: true,
    bootstrap: {
      distinctID: subscriberId
    }
  })
}

export function posthogCapture (eventName: string, properties: typeof Property): void {
  if (!posthogEnabled()) return

  logger.info(`Capturing Posthog event: ${eventName}, properties: ${JSON.stringify(properties)}`)
  posthog.capture(eventName, properties)
}

export function loadFeatureFlags (customerId: string, subscriberId: string): Promise<Object> {
  if (!posthogEnabled()) return Promise.resolve({})

  logger.info(`Loading Posthog Feature Flags, customerId: ${customerId}, subscriberId: ${subscriberId} ...`)
  return new Promise((resolve) => {
    try {
      posthog.group('company', customerId, { customerId })
      posthog.identify(subscriberId, { customerId })
      posthog.reloadFeatureFlags()
      posthog.onFeatureFlags((_, variants) => resolve(variants))
    } catch (error) {
      logger.info(`Posthog error when reloading feature flags: ${error.message}`)
      resolve({})
    }
  })
}

export async function isHiddenByFeatureFlag (customerId: string, subscriberId: string): Promise<boolean> {
  if (!posthogEnabled()) return false

  try {
    // Thiago; 15.03.2023; Feature flags with *Release conditions* sometimes are not loaded
    // in the first request, so it is necessary a second attempt to load them.
    if (posthog.featureFlags.getFlagVariants().chatchamp_visible === undefined || posthog.featureFlags.getFlagVariants().chatchamp_visible === false) await loadFeatureFlags(customerId, subscriberId)
    if (posthog.featureFlags.getFlagVariants().chatchamp_visible === 'chatchamp_hidden') return true
  } catch (error) {
    logger.error(`Posthog error when checking chatbot hidden: ${error.message}`)
  }

  return false
}
